import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { SalesImportsService } from '@app/core/reports/services/sales-imports.service';

@Component({
  selector: 'cnc-rfq-details-sales',
  templateUrl: './rfq-details-sales.component.html',
  styleUrls: ['./rfq-details-sales.component.scss'],
})
export class RfqDetailsSalesComponent implements OnInit, OnDestroy {
  @Input() rfq;

  pageTitle :string;

  view :any[] = [980, 500];

  legend :boolean = true;
  showLabels :boolean = true;
  animations :boolean = true;
  xAxis :boolean = true;
  yAxis :boolean = true;
  showYAxisLabel :boolean = true;
  showXAxisLabel :boolean = true;
  axisLabels :any = {
    qty: { x: 'Month Year', y: 'Quantity' },
    total: { x: 'Month Year', y: 'Total Amount' },
  };
  timeline :boolean = true;
  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5'],
  };

  chartData :any[];
  loading :boolean = false;
  subscription :Subscription;

  constructor(
    public salesImportSvc :SalesImportsService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnDestroy() :void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.pageTitle = this.rfq.product_name;
    this.getMonthlySummary();
    // console.log(this.rfq);
  }

  getMonthlySummary() {
    if (!this.rfq) {
      return;
    }

    const skus :any[] = this.rfq.alternate_skus
      ? this.rfq.alternate_skus.map((row) => row.alternate_sku)
      : [];
    if (this.rfq.internal_sku) {
      skus.push(this.rfq.internal_sku);
    }
    if (skus.length == 0) {
      return;
    }

    this.subscription = this.salesImportSvc
      .getMonthlySummary({ invp: 1, sku: skus })
      .subscribe((summary :any) => {
        const chartData :any[] = [
          {
            name: 'Sale Quantity',
            series: [],
          },
          {
            name: 'Sale Total',
            series: [],
          },
        ];

        summary.forEach((row) => {
          chartData[0].series.push({
            name: row.month + ' ' + row.year,
            value: row.total_quantity,
          });
          chartData[1].series.push({
            name: row.month + ' ' + row.year,
            value: row.total,
          });
        });

        this.chartData = chartData;
        this.loading = false;

        this.cd.detectChanges();
      });
  }
}
